// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"a905cad6","130":"9f313961","239":"a3cf59dc","358":"2745711b","453":"0f3c9974","570":"e9188be7","721":"1b70f012","732":"288fe764","977":"fcec22b5"}[chunkId] + ".chunk.js";
};